import DocumentMark from './DocumentMark/DocumentMark';
import Documents from './Documents/Documents';
import PolicyAnalysis from './PolicyAnalysis/PolicyAnalysisIcon';
import Logo from './Logo/Logo';
import PolicyPerformance from './PolicyPerformance/PolicyPerformance';
import PortfolioBuilder from './PortfolioBuilder/PortfolioBuilder';
import Statistic from './Statistic/Statistic';
import LogoWithText from './Logo/LogoWithText';
import Recommendations from './Recommendations/Recommendations';
import Delete from './Delete/Delete';
import LoadingWrapper from './LoadingWrapper/LoadingWrapper';
import Pound from './Pound/Pound';
import Logout from './Logout/Logout';
import Case from './Case/Case';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { ReactComponent as CaseIcon } from 'assets/icons/cases.svg';
import { ReactComponent as RiskIcon } from 'assets/icons/risk.svg';
import { ReactComponent as PolicyIcon } from 'assets/icons/existing.svg';
import { ReactComponent as RecommendationIcon } from 'assets/icons/recommendation.svg';
import { ReactComponent as ChargesIcon } from 'assets/icons/charges.svg';
import { ReactComponent as IpsIcon } from 'assets/icons/IPS.svg';
import { ReactComponent as SettingsIcon } from 'assets/icons/setting.svg';
import { ReactComponent as LogoutIcon } from 'assets/icons/logout.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete_bin.svg';
import { ReactComponent as TimeIcon } from 'assets/icons/procesing.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { ReactComponent as SearchIcon } from 'assets/icons/search_icon.svg';
import { ReactComponent as HelpOutlineIcon } from 'assets/icons/HelpOutlineIcon.svg';
import { ReactComponent as HomeIcon } from 'assets/icons/home.svg';
import { ReactComponent as ErrorIcon } from 'assets/icons/errorIcon.svg';
import { ReactComponent as RightArrow } from 'assets/icons/arrow_forward.svg';
import { ReactComponent as BackArrow } from 'assets/icons/back_arrow.svg';
import { ReactComponent as CopyIcon } from 'assets/icons/copy.svg';
import { ReactComponent as FollowOnIcon } from 'assets/icons/next_plan.svg';
import AddIcon from './Add/Add';
import { ReactComponent as Notifications } from 'assets/icons/notifications.svg';
import { ReactComponent as BarTrendUp } from 'assets/icons/bar_trend_up.svg';
import { ReactComponent as Support } from 'assets/icons/support.svg';
import Success from 'assets/icons/animatedSvgs/success';
import Failure from 'assets/icons/animatedSvgs/failure';

export default {
  DocumentMark,
  Documents,
  PolicyAnalysis,
  Logo,
  PolicyPerformance,
  PortfolioBuilder,
  Statistic,
  LogoWithText,
  Recommendations,
  Delete,
  LoadingWrapper,
  Pound,
  Case,
  Logout,
  HelpIcon: HelpOutlineIcon,
  CaseIcon,
  RiskIcon,
  PolicyIcon,
  RecommendationIcon,
  ChargesIcon,
  IpsIcon,
  SettingsIcon,
  LogoutIcon,
  CloseIcon,
  TimeIcon,
  EditIcon,
  DeleteIcon,
  SearchIcon,
  HomeIcon,
  ErrorIcon,
  RightArrow,
  Edit: EditOutlinedIcon,
  BackArrow,
  CopyIcon,
  FollowOnIcon,
  AddIcon,
  Notifications,
  Success,
  Failure,
  BarTrendUp,
  Support
};
